import createProductLayout from '../../main-layout/createProductLayout';
import Illustration from '../../main-layout/illustration/Illustration';
import Body from '../../main-layout/body/Body';
import ButtonContainer from '../../main-layout/cta-components/ButtonContainer';
import { standardGrid } from '../../main-layout/styles';
import ViHeader from './ViHeader';
import ViReadMore from './ViReadMore';
const ViLayout = createProductLayout({
  coreComponents: {
    Illustration,
    Header: ViHeader,
    Body,
    ReadMore: ViReadMore,
    Cta: ButtonContainer
  },
  defaultGrid: standardGrid
});
export default ViLayout;
//# sourceMappingURL=ViLayout.js.map